import { Injectable } from "@angular/core";
import { TPModule } from "../api-generated/model/tPModule";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalModuleService extends BaseService<TPModule> {}
